import React from 'react'

const Avatar = React.forwardRef((props: { user: any }, ref: any) => {
	const getInitials = () => {
		const { user } = props
		let fullName =
			user?.attributes?.firstname + ' ' + user?.attributes?.lastname
		let names = fullName.split(' '),
			initials = names[0].substring(0, 1).toUpperCase()

		if (names.length > 1) {
			initials += names[names.length - 1].substring(0, 1).toUpperCase()
		}
		return initials
	}

	const initials = getInitials()
	return (
		<div
			ref={ref}
			className="overflow-hidden flex items-center justify-center rounded-full bg-white w-12 h-12 border border-gray-300 text-center"
		>
			<span className="text-gray-700 font-bold">{initials}</span>
		</div>
	)
})
Avatar.displayName = 'Avatar'
export default Avatar
